import { render, staticRenderFns } from "./addPermissionDialog.vue?vue&type=template&id=0d6fb11b&scoped=true&"
import script from "./addPermissionDialog.vue?vue&type=script&lang=js&"
export * from "./addPermissionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6fb11b",
  null
  
)

export default component.exports